import { ComponentProps } from 'react';
import { bordColorTheme } from '../../../../styles/styles.constants';

/**
 * Icono de capas/layers para BordOneToneIcon
 */
const BordCapsIcon = (props: ComponentProps<'svg'>) => {
  const { stroke } = props;
  return (
    <svg viewBox="0 0 21 21" fill="none">
      <path
        d="M1.73933 4.53934C0.760704 5.12573 0.761014 5.97116 1.73459 6.55947C2.69244 7.13829 3.69125 7.7298 4.83171 8.27693C5.97216 8.82406 7.20513 9.30322 8.41164 9.76275C9.63794 10.2298 11.4002 10.23 12.6225 9.76049C13.8184 9.30111 15.0387 8.82126 16.1732 8.27695C17.3079 7.73264 18.3081 7.14724 19.2656 6.57348C20.2442 5.98709 20.2439 5.14167 19.2703 4.55335C18.3125 3.97453 17.3137 3.38302 16.1732 2.8359C15.0328 2.28878 13.7998 1.8096 12.5933 1.35007C11.367 0.883006 9.60473 0.882857 8.38245 1.35234C7.18648 1.81171 5.96625 2.29156 4.83166 2.83587C3.69706 3.3802 2.69687 3.96558 1.73933 4.53934Z"
        stroke={stroke || bordColorTheme.navyBlue[400]}
      />
      <path
        d="M19.9998 11.6935C18.9621 12.2672 17.8781 12.8526 16.6484 13.3969C15.4188 13.9412 14.0963 14.4211 12.8001 14.8805C11.4754 15.3499 9.56551 15.3497 8.23646 14.8827C6.92888 14.4232 5.59259 13.944 4.3566 13.3969C3.12059 12.8498 2.03811 12.2583 1 11.6794"
        stroke={stroke || bordColorTheme.navyBlue[400]}
        strokeLinecap="round"
      />
      <path
        d="M19.9998 16.4422C18.9621 17.016 17.8781 17.6014 16.6484 18.1457C15.4188 18.69 14.0963 19.1699 12.8001 19.6293C11.4754 20.0987 9.56551 20.0985 8.23646 19.6316C6.92888 19.172 5.59259 18.6929 4.3566 18.1457C3.12059 17.5986 2.03811 17.007 1 16.4282"
        stroke={stroke || bordColorTheme.navyBlue[400]}
        strokeLinecap="round"
      />
    </svg>
  );
};

export default BordCapsIcon;
